import { requestService as api } from "../Request.service"  
const API_URL = {
  API_MANAGE: `/ERP/reports/manage.php`,
  API_GETCALCULATEMATERIAL: `/ERP/reports/CalculateMaterial/getCalculateMaterial.php`,
  API_GETCALCULATEMATERIALDOWNLOAD: `/ERP/reports/CalculateMaterial/getCalculateMaterial-download.php`,
  API_PREPARECALCULATEMATERIAL: `/ERP/reports/CalculateMaterial/prepareCalculateMaterial.php`,
  API_GETCALCULATEMATERIALBYPRODUCT: `/ERP/reports/CalculateMaterial/getCalculateMaterialByProduct.php`,

  API_GETCODE: `/ERP/reports/get-jocode.php`,

  API_GETSALESHISTORY: `/ERP/reports/SalesHistory/getSalesHistory.php`,
  API_GETSALESHISTORYDETAIL: `/ERP/reports/SalesHistory/getSalesHistoryDetail.php`,

  API_GETSTOCKSUMMARY: `/ERP/reports/StockSummary/getStockSummary.php`,
  API_GETSTOCKMINALERT: `/ERP/reports/StockSummary/getStockMinAlert.php`,

  API_GETPOPENDING: `/ERP/reports/PoPending/getPoPending.php`,

  API_GETSIZEWEIGHT: `/ERP/reports/SizeWeight/get-size-weight.php`,
  API_GETSIZEWEIGHTDOWNLOAD: `/ERP/reports/SizeWeight/get-size-weight-download.php`,

  API_GETMATERIALUSAGE: `/ERP/reports/MaterialUsage/getMaterialUsage.php`,
  API_GETMATERIALUSAGEDOWNLOAD: `/ERP/reports/MaterialUsage/getMaterialUsage-download.php`,
  API_MATERIALOPTIONS: `/ERP/reports/MaterialUsage/options-material-all.php`,
};
  
const ReportService = () => { 
  
  const getCalculateMaterial = (parm = {}) => api.post(`${API_URL.API_GETCALCULATEMATERIAL}`, parm);
  // const getCalculateMaterialDownload = (parm = {}, config = {}) => api.post(`${API_URL.API_GETCALCULATEMATERIALDOWNLOAD}`, parm, {...config, cancle: true});

  const getCalculateMaterialDownload = (payload) => api({
        method: 'post',
        url: API_URL.API_GETCALCULATEMATERIALDOWNLOAD,
        data: payload,
        responseType: 'blob', // Set responseType to 'blob' to handle binary data (like files)
      })
      .then(response => {  
        const blob = new Blob([response.data], { type: response.headers['content-type'] }); 
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute('download', `รายงานคำนวนวัถตุดิบ.xlsx`);
        link.target = "_bank";
        document.body.appendChild(link);
        link.click();
         
        document.body.removeChild(link);
      });

  const prepareCalculateMaterial = (parm = {}, config = {}) => api.post(`${API_URL.API_PREPARECALCULATEMATERIAL}`, parm, {...config, cancle: true});

  const getCalculateMaterialByProduct = (parm = {}) => api.post(`${API_URL.API_GETCALCULATEMATERIALBYPRODUCT}`, parm);


  
  

  const getSalesHistory = (parm = {}) => api.post(`${API_URL.API_GETSALESHISTORY}`, parm);
  const getSalesHistoryDetail = (parm = {}) => api.post(`${API_URL.API_GETSALESHISTORYDETAIL}`, parm);

  const getStockSummary = (parm = {}) => api.post(`${API_URL.API_GETSTOCKSUMMARY}`, parm);
  /* รายงาน PO ค้างรับ (มุมมองปฏิทิน) */
  const getPoPending = (parm = {}) => api.post(`${API_URL.API_GETPOPENDING}`, parm);

  const getStockMinAlert = (parm = {}) => api.post(`${API_URL.API_GETSTOCKMINALERT}`, parm);

  const getSizeWeight = (parm = {}) => api.post(`${API_URL.API_GETSIZEWEIGHT}`, parm);

  const getSizeWeightDownload = (payload) => api({
        method: 'post',
        url: API_URL.API_GETSIZEWEIGHTDOWNLOAD,
        data: payload,
        responseType: 'blob',
      })
      .then(response => {
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute('download', `ขนาด-น้ำหนัก NSF.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
      });

  /* ---- รายงานการใช้ส่วนผสมตาม Job Order ---- */
  const getMaterialUsage = (parm = {}) => api.post(`${API_URL.API_GETMATERIALUSAGE}`, parm);

  const materialOptions = (keyword = "") =>
    api.get(`${API_URL.API_MATERIALOPTIONS}?keyword=${encodeURIComponent(keyword)}`, {
      ignoreLoading: true,
    });

  const getMaterialUsageDownload = (payload) =>
    api({
      method: "post",
      url: API_URL.API_GETMATERIALUSAGEDOWNLOAD,
      data: payload,
      responseType: "blob",
    }).then((response) => {
      const blob = new Blob([response.data], { type: response.headers["content-type"] });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute("download", `การใช้ส่วนผสมตาม JO.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(link.href);
    });

  return {
    getMaterialUsage,
    materialOptions,
    getMaterialUsageDownload,
    getCalculateMaterial,
    getCalculateMaterialDownload,
    getCalculateMaterialByProduct,
    prepareCalculateMaterial,
    getSalesHistory,
    getSalesHistoryDetail,
    getStockSummary,
    getStockMinAlert,
    getPoPending,
    getSizeWeight,
    getSizeWeightDownload,
  };
};

export default ReportService;